/**
 * Auth tract entry - mount острова LoginApp (страница /login).
 *
 * Канон pass.js: конфиг data-атрибутами с mount-ноды (volt пишет
 * auth_token/domain), vendor-chunk общий - volt линкует
 * ['vendor','auth']. redirect остров читает сам из query (канон
 * Login.vue донора).
 */
import { createApp } from 'vue';
import http from './plugins/http';
import LoginApp from '../components/Account/LoginApp.vue';

const mount = document.getElementById('login-app');

if( mount ) {

    const { authToken, domain } = mount.dataset;

    const app = createApp( LoginApp, {
        authToken : authToken || '',
        domain    : domain || '',
    } );

    app.use(http);
    app.mount( mount );
}
